import { createSlice } from "@reduxjs/toolkit";

const doulaSlice = createSlice({
    name: "doula",
    initialState: {
        servizio: {},
        lettura: {},
        isLoading: true,
    },
    reducers: {
        replaceIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        replaceServizio: (state, action) => {  
            state.servizio = action.payload;
        },
        replaceLettura: (state, action) => {  
            state.lettura = action.payload;
        },
    },
});

export const doulaActions = doulaSlice.actions;

export default doulaSlice;
